import { useI18N } from "@customer-tools-web/component-i18n";
import { mediaMax, TextButton } from "@customer-tools-web/component-ui";
import * as React from "react";
import styled from "styled-components";

import { useLoginAsAgent } from "../hooks/useLoginAsAgent";

export function LoginAsAgentHint() {
  const {
    isLoginAsAgent,
    info: { email },
    logout,
  } = useLoginAsAgent();
  const { t } = useI18N();

  if (!isLoginAsAgent) {
    return null;
  }

  return (
    <LoginAsAgentWrapper data-test="login-as-agent-hint-wrapper">
      <p className="info-wrapper">
        <span className="perfix">{t("loginAsAgent.info.perfix")}</span>
        <span className="email">{email}</span>
      </p>
      <TextButton className="logout-wrapper" onClick={logout}>
        {t("loginAsAgent.logout.button")}
      </TextButton>
    </LoginAsAgentWrapper>
  );
}

const LoginAsAgentWrapper = styled.div`
  height: 48px;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.textColor};
  justify-content: center;

  ${mediaMax.sm`
    font-size: ${(props: any) => props?.theme?.fontSize?.caption};
    justify-content: space-between;
    .info-wrapper {
      max-width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `};

  .info-wrapper {
    margin: 0 24px 0 0;
    color: ${(props) => props.theme.white};
    font-weight: 400;
    .email {
      white-space: nowrap;
    }
  }

  .logout-wrapper {
    color: ${(props) => props.theme.white};
    text-decoration: underline;
    font-weight: 600;
  }
`;

export default LoginAsAgentHint;
